// src/redux/order/order.types.js
export const OrderActionTypes = {
  CREATE_ORDER: 'CREATE_ORDER',
  FETCH_ORDERS: 'FETCH_ORDERS',
  SET_ORDERS: 'SET_ORDERS',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ORDER: 'CLEAR_ORDER',
  UPDATE_ORDER: 'UPDATE_ORDER'
};